// extracted by mini-css-extract-plugin
export default {"columnaPrincipal":"HomeTorneosInt_columnaPrincipal__7hfMK","contenedorCuadros":"HomeTorneosInt_contenedorCuadros__uTUUi","columnaLateral":"HomeTorneosInt_columnaLateral__0oR12"};